module.exports = __webpack_public_path__ + "static/media/Agrabiz Service_Terms And Conditions_DE.a311a99f.pdf";